<template>
  <div>
    <LoadingPage v-if="loadingUser" />

    <div v-else>
      <CustomerEditAccount :userData="userData" />
    </div>
  </div>
</template>

<script>
import LoadingPage from "@core/components/LoadingPage";
import { mapActions, mapState } from "vuex";
import CustomerEditAccount from "./CustomerEditAccount.vue";

export default {
  components: {
    CustomerEditAccount,
    LoadingPage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userData: (s) => s.user.detail.userData,
      loadingUser: (s) => s.user.detail.loading,
    }),
  },
  async created() {
    await this.syncDetail();
  },
  methods: {
    ...mapActions({
      fetchUser: "user/detail/asyncUser",
    }),
    async syncDetail() {
      await this.fetchUser({ id: this.$router.currentRoute.params.id });
    },
  },
};
</script>
